import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FotaBatchReportsComponent } from './fota-batch-reports.component';

const routes: Routes = [
  {
    path: 'fota-batch-report',
    component: FotaBatchReportsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FotaBatchReportsRoutingModule {}
